// ボタン右寄せ用棚
import React from 'react';
import { Row, Col } from 'react-bootstrap';

const RowRightButton: React.FC = ({ children }) => {
  return (
    <Row className="row-right-button">
      <Col xl={6} lg={6} md={6} sm={6} xs={12} />
      <Col className="text-right" xl={6} lg={6} md={6} sm={6} xs={12}>
        {children}
      </Col>
    </Row>
  );
};

export default RowRightButton;
